export const generatePrivateRoomUrl = (
  privateRoomId: string,
  creditsPrice: string,
) => {
  let spaceUrl = "";

  if (privateRoomId) {
    spaceUrl = `${
      import.meta.env.VITE_PORTAL_URL
    }/workspaces/private-office/details/${privateRoomId}`;
  }

  if (creditsPrice) {
    spaceUrl += `?credits_price=${creditsPrice}`;
  }

  return spaceUrl;
};
